import { AfterViewInit, Component, ElementRef, Inject, OnInit, Signal, ViewChild, WritableSignal, computed, signal, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ModalConfig } from 'frontend/src/app/classes/modal-config';
import moment from 'moment';

@Component({
  selector: 'eaglei-refinery-info-modal',
  templateUrl: './refinery-info-modal.component.html',
  styleUrls: ['./refinery-info-modal.component.scss'],
  standalone: false
})
export class RefineryInfoModalComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  private content: Signal<ElementRef> = viewChild('content');

  // Data Properties
  public alertData: any[];
  public regionInfo: any;
  public refineryInfo: any;
  public isPlanned: WritableSignal<boolean> = signal(false);
  public isRefineryLevel: boolean;

  // Table Properties
  public dataSource: MatTableDataSource<any>;
  private readonly alertColumns: string[] = ['fac_name', 'unit_name', 'unit_cat', 'prod_class', 'dis_date', 'actions'];
  private readonly plannedColumns: string[] = ['fac_name', 'unit_name', 'outage_type', 'status', 'start_date', 'end_date', 'obser_start', 'obser_end', 'actions'];
  public columnNames: Signal<string[]> = computed(() => {
    return (this.isPlanned()) ? [...this.plannedColumns] : [...this.alertColumns];
  });
  public selectedRow: any = undefined;

  constructor(public dialogRef: MatDialogRef<RefineryInfoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.regionInfo = data.regionInfo;
    this.refineryInfo = data.refineryInfo;
    this.alertData = data.dataTable;
    this.isPlanned.set(data.isPlanned);
    this.isRefineryLevel = data.isRefineryLevel || false;
  }

  public ngAfterViewInit(): void {
    this.initData();
  }

  public initData(): void {
    if (this.dataSource) {
      this.dataSource.data = this.alertData;
    } else {
      this.dataSource = new MatTableDataSource(this.alertData);
      this.dataSource.sortingDataAccessor = this.dataAccessor.bind(this);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }
  }

  public dataAccessor(data: any, column: string): string | number {
    switch (column) {
      case 'fac_name':
        return data.facility_name || data.name;
      case 'unit_name':
        return data.unit_name;
      case 'unit_cat':
        return data.unit_category;
      case 'prod_class':
        return data.product_class;
      case 'dis_date':
        return moment(data.distributed_datetime).valueOf();
      case 'outage_type':
        return data.outage_type;
      case 'status':
        return data.status;
      case 'start_date':
        return moment(data.expected_start_date).valueOf();
      case 'end_date':
        return moment(data.expected_end_date).valueOf();
      case 'obser_start':
        return moment(data.observed_start_date).valueOf();
      case 'obser_end':
        return moment(data.observed_end_date).valueOf();
      default:
        return '';
    }
  }

  public toggleExpandedRow(row: any): void {
    if (this.selectedRow === row) {
      this.selectedRow = undefined;
      return;
    }

    this.selectedRow = row;
  }

  public getConfidenceLabel(id: number): string {
    switch (id) {
      case 1:
        return 'Unvierfied Source';
      case 2:
        return 'Single Source';
      case 3:
        return 'Multiple Sources';
      case 4:
        return 'Company Verified';
      default:
        return 'UNKNOWN'
    }
  }

  private setModalHeight() {
    (this.content().nativeElement as HTMLElement).style.maxHeight = ModalConfig.getMaxModalHeight() + 'px';
  }

}
